import { z } from 'zod';

import type { FieldConfig } from '@/types/forms';

const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;
const PHONE_REGEX = /^\+?[0-9\s\-().]{7,15}$/;

export const schema = z.object({
  fullName: z.string().min(3, 'Full name must be at least 3 characters'),
  dateOfBirth: z.string().regex(DATE_REGEX, 'Enter a valid date (DD/MM/YYYY)'),
  address: z.string().min(5, 'Please enter a complete address'),
  phone: z.string().regex(PHONE_REGEX, 'Enter a valid phone number'),
  message: z.string().min(20, 'Message must be at least 20 characters'),
  date: z.string().regex(DATE_REGEX, 'Enter a valid date (DD/MM/YYYY)'),
});

export type SubmitComplaintFormValues = z.infer<typeof schema>;

export const defaultValues: SubmitComplaintFormValues = {
  fullName: '',
  dateOfBirth: '',
  address: '',
  phone: '',
  message: '',
  date: '',
};

export const fields: FieldConfig[] = [
  {
    name: 'fullName',
    type: 'text',
    label: 'Full Name',
    placeholder: 'Jane Smith',
    required: true,
    colSpan: 1,
  },
  {
    name: 'dateOfBirth',
    type: 'date',
    label: 'Date of Birth',
    required: true,
    colSpan: 1,
  },
  {
    name: 'address',
    type: 'text',
    label: 'Address',
    placeholder: '123 Main Street',
    required: true,
    colSpan: 1,
  },
  {
    name: 'phone',
    type: 'tel',
    label: 'Phone',
    placeholder: '+44 000 000 0000',
    required: true,
    colSpan: 1,
  },
  {
    name: 'message',
    type: 'textarea',
    label: 'Message',
    placeholder: 'Describe your complaint...',
    required: true,
    colSpan: 2,
    maxLength: 1000,
  },
  {
    name: 'date',
    type: 'date',
    label: 'Date',
    required: true,
    colSpan: 2,
  },
];
